"use client"

import React from 'react';
import {useAppStore} from "@/store/AppStore";
import {TreeItem} from "@mui/x-tree-view/TreeItem";
import {CircularProgress} from "@mui/material";
import useLiturgiesData from "@/utils/hooks/useLiturgiesData";
import {Liturgy} from "@/types/Liturgies";

export default function LiturgiesItems() {

  const user = useAppStore((state) => state.user);
  const data = useLiturgiesData(user?.access_token)

  const items = data?.items

  if (!user) return null
  if (!data) return <CircularProgress/>

  return (
    <>
      {items && items.map((itm: Liturgy, key: number) => {
        return <TreeItem key={key} label={itm.name} itemId={`liturgy-${itm.id}`}/>
      })
      }
    </>
  )
}
